import React from "react";

export default function TrustpilotReviews() {
  // Static mirror of the reviews you provided (no scraping).
  const reviews = [
    {
      title: "Professional, reliable and highly recommended",
      body: [
        "Having worked with this team for years, whilst they were exclusive to referrals and long standing clients, I can’t praise them enough. Especially now that they’ve opened their doors to the wider market.",
        "Over the past ten years, I’ve channelled the surplus from my businesses into property and also invested on behalf of my parents for their retirement. This team have guided us with clear strategies, helping us acquire the right properties in London, Manchester, Birmingham and Liverpool that have performed in line (or better!) with the clear and precise recommendation that we received.",
        "What sets them apart is their ability to provide a complete end to end service. They don’t just find the great deals, they go above and beyond taking the time to answer every question thoroughly and with genuine care, while offering long-term guidance and support to ensure your assets are working at their best. I would recommend them without hesitation."
      ],
      author: "Eleanor",
      when: "1 day ago",
      source: "Automatic Invitation"
    },
    {
      title: "Tailored Guidance from the beginning.",
      body: [
        "From the very beginning, the team demonstrated a genuine commitment to understanding what my family and I wanted to achieve with our investments. The preparatory conversations were in-depth and thoughtful, ensuring they had a solid grasp of our goals, concerns, and long-term aspirations.",
        "They clearly articulated the available options, breaking down complex financial concepts into digestible insights. I especially appreciated the materials they prepared in advance of our meetings — they were informative, well-structured, and tailored to our specific needs, which made decision-making much easier.",
        "The advice we received was not only professional but also warm and friendly. It was evident that we were working with experienced individuals who cared about our outcomes. They covered aspects we hadn’t even considered, bringing a level of foresight and expertise that gave us real confidence in the process.",
        "I truly couldn’t recommend them highly enough. If you're looking for guidance that’s both strategic and personal, then look no further."
      ],
      author: "Emma James",
      when: "Updated 15 Oct 2025",
      source: "Organic"
    },
    {
      title: "Felt properly looked after",
      body: [
        "The team were calm, clear and patient with me from the start. I asked loads of questions and they always took time to explain things. Never felt like a sales pitch — just honest advice from people who know what they’re doing. Would defo recommend if you want things simple and stress free."
      ],
      author: "Bia",
      when: "13 Oct 2025",
      source: "Automatic Invitation"
    },
    {
      title: "Thoughtful advice that leads to smart action",
      body: [
        "Referred by a colleague, I came to Ethira for financial guidance. They built a long-term plan around my goals, stress tested the numbers, and only then recommended a property that genuinely fit. Clear communication, smooth co-ordination with the recommended brokers and solicitors, and ongoing check-ins since completion. No hype — just careful, data-led advice that gives me confidence. Would recommend them without hesitation."
      ],
      author: "Sam Frank",
      when: "10 Oct 2025",
      source: "Automatic Invitation"
    }
  ];

  return (
    <section className="max-w-6xl mx-auto px-6 py-10">
      <h2 className="text-2xl font-semibold mb-6">What our clients say</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {reviews.map((r, idx) => (
          <article key={idx} className="rounded-xl border p-5 shadow-sm bg-white">
            <div className="flex items-center gap-2 mb-3">
              <span className="inline-flex -space-x-0.5">
                {[...Array(5)].map((_,i)=>(
                  <span key={i} className="w-4 h-4 inline-block" aria-hidden>
                    <svg viewBox="0 0 20 20" fill="#00B67A"><path d="M10 .4l2.6 6.3 6.8.5-5.2 4.3 1.7 6.7-5.9-3.6-5.9 3.6 1.7-6.7L.6 7.2l6.8-.5L10 .4z"/></svg>
                  </span>
                ))}
              </span>
              <span className="text-xs text-slate-500">{r.when}</span>
            </div>
            <h3 className="text-lg font-semibold">{r.title}</h3>
            {r.body.map((p,i)=>(<p key={i} className="mt-2 text-slate-700">{p}</p>))}
            <div className="mt-4 text-sm text-slate-500">
              <span>by {r.author}</span>
              <span className="mx-2">•</span>
              <span>Source: {r.source}</span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
